import * as React from 'react';

const TextAreaField = (props) => {
  const {
          autoComplete,
          className,
          defaultValue,
          disabled,
          input,
          meta,
          placeholder,
          rows,
          style,
        } = props;

  const setDefaultValue = React.useCallback(() => {
    if (!meta.touched && defaultValue && defaultValue !== input.value) {
      input.onChange(defaultValue);
    }
  }, [defaultValue, input.value, meta.touched]);

  React.useEffect(() => {
    setDefaultValue();
  }, [setDefaultValue]);

  return (
    <textarea
      {...input}
      autoComplete={autoComplete}
      className={className}
      disabled={disabled}
      placeholder={placeholder}
      rows={rows}
      style={style}
    />
  );
};

export default TextAreaField;